import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination } from "swiper";
import "swiper/css/pagination";
import profilePic1 from "../../img/profile1.jpg";
import profilePic2 from "../../img/profile2.jpg";
import profilePic3 from "../../img/profile3.jpg";
import profilePic4 from "../../img/profile4.jpg";

const Testimonial = () => {
  const clients = [
    {
      img: profilePic1,
      review:
    
      <span>"AL-ISKAN's cost-effective designs are well detailed and lend to ease of construction, saving time and money." - Mrs. Khaloud Khamis Ahamed Al Shaaibi</span>
  
   
    },
    {
      img: profilePic2,
      review:
      <span>"The collaborative team at AL-ISKAN face-lifted the early completion of all phases and overall completion of the project." - Mr. Hussain Ali Nasser Al Alawi</span>
    },
    {
      img: profilePic3,
      review:
      <span>"Excellent Service, fast and professional! Every time I call they are available to answer questions, communication was excellent and their fee is reasonable." - Mr. Sultan khamis Salim Al Mukhaini</span>
    },
    {
      img: profilePic4,
      review:
      <span>"AL-ISKAN does a great job and I would highly recommend them to others." - Mr. Salem Abdullah Rashid Al Araimi</span>
    },
  ];

  return (
    <div className="t-wrapper" id="testimonial">
      <div className="t-heading">
        <span>Clients always get </span>
        <span>Quality services </span>
        <span>from us...</span>
      <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
      

      </div>
      <Swiper
        // install Swiper modules
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <img src={client.img} alt="" />
                <span>{client.review}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;